import { FC, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { UiIcon, UiTitle, UiText } from '@frontend/znanie-uikit';
import Image from 'next/legacy/image';

import HtmlContent from 'components/common/HtmlContent';
import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import { useContentAnalytics } from '../../DailyQuestion.hooks';

import * as U from './ResultBlock.utils';
import * as T from './ResultBlock.types';
import css from './ResultBlock.module.scss';

export const ResultBlock: FC<T.IResultBlock> = (props) => {
  const { isDesktopXl } = useMediaQueries();

  const questionRef = useRef<HTMLDivElement>(null);
  const mobileAnimationRef = useRef<HTMLDivElement>(null);
  const desktopAnimationRef = useRef<HTMLDivElement>(null);

  const [isClosed, setClosed] = useState<boolean>(false);

  const multiplier = props.multiplier ?? 1;

  const score = props.isAnswerRight ? 10 * multiplier : 1 * multiplier;

  const closeHandler = () => {
    setClosed(true);

    props.onClose();
  };

  useEffect(() => {
    if (props.isAnswerRight) {
      if (isDesktopXl) {
        U.runAnimation(desktopAnimationRef, props.isDarkTheme);
      } else {
        U.runAnimation(mobileAnimationRef, props.isDarkTheme);
      }
    }
  }, [props.isAnswerRight]);

  useContentAnalytics(questionRef, [props.question]);

  return (
    <div className={css.container}>
      <div className={css.imageBlock}>
        <div className={css.controlBlock}>
          <div className={cn(css.userScoreWrapper, css.isMobileOnly)}>
            +{score} <UiIcon name="roz-logo-circle" size={22} />
            <div ref={mobileAnimationRef} className={css.animationMount} />
          </div>

          <div
            className={cn(css.closeButton, isClosed && css.pressed)}
            onClick={closeHandler}
          >
            <UiIcon name="close" size={14} />
          </div>
        </div>

        {props.image && (
          <div
            className={cn(css.imageWrapper, props.isDarkTheme && css.darkTheme)}
          >
            <Image
              src={props.image}
              layout="fill"
              alt="Иллюстрация вопроса"
              objectFit="contain"
              objectPosition="top"
            />
          </div>
        )}
      </div>

      <div className={css.leftBlock}>
        <UiTitle className={cn(css.title, props.isDarkTheme && css.darkTheme)}>
          <HtmlContent html={props.question} ref={questionRef} />
        </UiTitle>

        <div className={css.resultsBlock}>
          <div className={cn(css.userScoreWrapper, css.isDesktopOnly)}>
            +{score} <UiIcon name="roz-logo-circle" size={22} />
            <div ref={desktopAnimationRef} className={css.animationMount} />
          </div>

          <div className={css.resultDescription}>
            <UiText>
              <>
                {props.isAnswerRight ? (
                  <span className={css.green}>Вы ответили верно!</span>
                ) : (
                  <span className={css.red}>Вы ответили неверно 😔</span>
                )}{' '}
                Завтра вас ждет новый вопрос 😉
              </>
            </UiText>
          </div>
        </div>

        <UiText
          className={cn(
            css.answerDescription,
            props.isDarkTheme && css.darkTheme
          )}
        >
          <HtmlContent html={props.answer} />
        </UiText>
      </div>
    </div>
  );
};
